export const pad = (num: number, size = 2) => {
  let stringNum = num.toString();

  while (stringNum.length < size) {
    stringNum = `0${stringNum}`;
  }

  return stringNum;
};

export const formatTime = (seconds: number) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);

  return `${pad(minutes)}:${pad(remainingSeconds)}`;
};
